const ShareToObj = (key, classes) => {
  const obj = {}
  obj[key] = { classes }

  return obj
}
export default ShareToObj
